export type keyType = {
  type: Symbol;
  value: string | React.ReactElement;
  rowSpan?: number;
  color?: string;
  size?: string;
  back?: string;
}

export type keyRowType = {
  [index: number]: keyType;
}

// export type keyRowType = [keyType];
// 键盘伸缩功能
export const SLIDE = Symbol.for('slide');
// 删除功能
export const BACKSPACE = Symbol.for('backspace');
// 切换下一个
export const SWITCH = Symbol.for('switch');
// od，os切换
export const EYE_TYPE_TOGGLE = Symbol.for('eyeTypeToggle');
// 输入值
export const TEXT = Symbol.for('text');

const keys: Array<keyRowType> = [
  // 第二行
  [{
    type: SLIDE,
    value: <i className="icon-yincangjianpan iconfont" />,
  }, {
    type: TEXT,
    value: '+',
  }, {
    type: TEXT,
    value: '-',
  }, {
    type: TEXT,
    value: '/',
  }, {
    type: TEXT,
    value: '@',
  }],
  // 第二行
  [{
    type: EYE_TYPE_TOGGLE,
    value: 'OD',
    rowSpan: 2,
  }, {
    type: TEXT,
    value: '1',
  }, {
    type: TEXT,
    value: '2',
  }, {
    type: TEXT,
    value: '3',
  }, {
    type: BACKSPACE,
    value: <i className="icon-tuige iconfont" />,
    rowSpan: 2,
  }],
  // 第三行
  [{
    type: TEXT,
    value: '4',
  }, {
    type: TEXT,
    value: '5',
  }, {
    type: TEXT,
    value: '6',
  }],
  // 第四行
  [{
    type: EYE_TYPE_TOGGLE,
    value: 'OS',
    rowSpan: 2,
  }, {
    type: TEXT,
    value: '7',
  }, {
    type: TEXT,
    value: '8',
  }, {
    type: TEXT,
    value: '9',
  }, {
    type: SWITCH,
    value: '下一项',
    rowSpan: 2,
    size: 'small',
    back: 'primary',
    color: 'white',
  }],
  // 第5行
  [{
    type: TEXT,
    value: '0',
  }, {
    type: TEXT,
    value: '.',
  }, {
    type: TEXT,
    value: '00',
    color: 'gray',
  }],
];

export default keys;